import * as React from 'react';
import { Box, BoxProps } from '@theme-ui/components';
import { BlockAlign, blockAlignMap, InlineAlign, inlineAlignMap } from './layout';

type InheritedProps = Omit<BoxProps, 'ref'>;
export interface StackProps extends InheritedProps {
  gap?: number | number[] | string | string[];
  align?: Exclude<BlockAlign, 'top' | 'bottom'>;
  alignY?: Exclude<InlineAlign, 'left' | 'right'>;
}

export const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ gap, align, alignY, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        {...props}
        // @ts-ignore
        __css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: align ? blockAlignMap[align] : undefined,
          justifyContent: alignY ? inlineAlignMap[alignY] : undefined,
          '> *:not(:last-child)': {
            marginBottom: gap
          }
        }}
      />
    );
  }
);
